import React, { useEffect } from 'react';
import Loader from '../common/Loader';
import MetaData from '../MetaData';
import { useDispatch, useSelector } from 'react-redux';
import { Container } from 'react-bootstrap';
import SectionHeading from '../common/SectionHeading';
import { useParams, Link } from 'react-router-dom';
import { toast } from 'react-hot-toast';
import { clearErrors, getOrderDetails } from '../../redux/actions/orderActions';

const OrderDetails = () => {
    const dispatch = useDispatch();
    const { error, order, loading } = useSelector((state) => state.orderDetails);

    const { id } = useParams();

    useEffect(() => {
        if (error) {
            toast.error(error);
            dispatch(clearErrors());
        }

        dispatch(getOrderDetails(id));
    }, [error]);

    return loading ? (
        <Loader />
    ) : (
        <>
            {/* <MetaData title={order?.name} /> */}
            <Container>
                <div className='myOrdersPage section-padding-top section-padding-bottom'>
                    <SectionHeading heading={'My Orders'} />
                    <div className='shippingContainer orderDetailsContainer'>
                        <h3 className='text-primary mb-3'>Order #{order?._id}</h3>
                        <div className='confirmShippingArea'>
                            <div>
                                <p>Name:</p>
                                <span>{order?.user.name}</span>
                            </div>
                            <div>
                                <p>Phone:</p>
                                <span>{order?.shippingInfo.phoneNo}</span>
                            </div>
                            <div>
                                <p>Address:</p>
                                <span>{`${order?.shippingInfo.address}, ${order?.shippingInfo.city}, ${order?.shippingInfo.state}, ${order?.shippingInfo.pinCode}, ${order?.shippingInfo.country}`}</span>
                            </div>
                        </div>
                        <h4 className='mt-5'>Payment</h4>
                        <div className='order-summary'>
                            <div>
                                <p
                                    className={
                                        order?.paymentInfo.status === 'succeeded'
                                            ? 'text-success'
                                            : 'text-danger'
                                    }
                                >
                                    {order?.paymentInfo.status === 'succeeded'
                                        ? 'PAID'
                                        : 'NOT PAID'}
                                </p>
                            </div>
                            <div>
                                <p>Amount:</p>
                                <span>Rs.{order?.totalPrice}</span>
                            </div>
                        </div>
                        <h4 className='mt-5'>Order Status</h4>
                        <div className='order-summary'>
                            <div>
                                <p
                                    className={
                                        order?.orderStatus === 'Delivered'
                                            ? 'text-success'
                                            : 'text-danger'
                                    }
                                >
                                    {order?.orderStatus}
                                </p>
                            </div>
                            <div>
                                <p>Amount:</p>
                                <span>Rs.{order?.totalPrice}</span>
                            </div>
                        </div>
                        <div className='confirmCartItems mt-5'>
                            <h4>Order Items</h4>
                            <div className='confirmCartItemsContainer'>
                                {order?.orderItems &&
                                    order?.orderItems.map((item, i) => (
                                        <div key={i} className='confirmCartItem'>
                                            <img src={item.image} alt={item.name} />
                                            <Link to={`/product/${item.product}`}>{item.name}</Link>
                                            <span className='text-end'>
                                                {item.quantity} X Rs.{item.price} ={' '}
                                                <b>Rs.{item.price * item.quantity}</b>
                                            </span>
                                        </div>
                                    ))}
                            </div>
                        </div>
                    </div>
                </div>
            </Container>
        </>
    );
};

export default OrderDetails;
